import { render, staticRenderFns } from "./ModuleProgressBar.vue?vue&type=template&id=b03dbb5c&"
import script from "./ModuleProgressBar.vue?vue&type=script&lang=js&"
export * from "./ModuleProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports